import client from '../clients';

const ZONES = {
  autocomplete(query) {
    const params = `q[name_or_zip_codes_agg_cont_any]=${encodeURIComponent(query)}`;
    return client.get('/autocompletes/zones', params);
  },
}

export default ZONES;
